import React,{useState,useEffect,useRef} from "react";

import pptxgen from "pptxgenjs";

import {useLocation,useNavigate} from "react-router-dom";

import axios from "../utils/axiosInstance";

import {useIdea} from "../context/IdeaContext";

import {useAuth} from "../context/AuthContext";

import IdeaPopup from "../pages/IdeaPopup";

import ModuleHeader from "../components/ModuleHeader";

import { buildMDIHPdfName } from "../utils/pdfNaming";

const PitchDeckGenerator=()=>{

const location=useLocation();

const navigate=useNavigate();

const {user}=useAuth();

const {selectedIdea,businessModel,aiTestingFeedback,gtmPlan}=useIdea();

const ideaId=
location.state?.ideaId ||
selectedIdea?.ideaId ||
null;

const contextData={

gtmPlan:
location.state?.gtmPlan || gtmPlan || {},

businessModel:
location.state?.businessModel || businessModel || {},

aiTestingFeedback:
location.state?.aiTestingFeedback || aiTestingFeedback || {},

selectedIdea:
location.state?.selectedIdea || selectedIdea || {}

};

/* RESOLVE STARTUP NAME (CONSISTENT WITH OTHER MODULES) */

const startupName =

contextData.selectedIdea?.ideaTitle ||

contextData.selectedIdea?.title ||

contextData.selectedIdea?.idea ||

contextData.selectedIdea?.problemStatement ||

contextData.businessModel?.startupName ||

contextData.businessModel?.idea ||

"Startup";

/* STARTUP DATA */

const startupData={

idea:contextData.selectedIdea,

gtmPlan:contextData.gtmPlan,

businessModel:contextData.businessModel,

aiTestingFeedback:contextData.aiTestingFeedback

};

/* STATE */

const [pitchDeck,setPitchDeck]=useState([]);

const [analysis,setAnalysis]=useState({});

const [investorQuestions,setInvestorQuestions]=useState([]);

const [improvements,setImprovements]=useState([]);

const [loading,setLoading]=useState(false);

const [decks,setDecks]=useState([]);

const [selectedDeckId,setSelectedDeckId]=useState(null);

const [showPopup,setShowPopup]=useState(false);

const [popupPayload,setPopupPayload]=useState(null);

const autoSaveTimersRef=useRef({});

const [saveStatus, setSaveStatus] = useState({});

/* AI TIP POPUP */

const triggerMotivation = async(context="")=>{

try{

const res = await axios.post(

"/api/pitchdeck/ai-tip",

{

context,

startupName,

ideaId

}

);

const tip =

res.data?.tip ||

"Your pitch is improving. Focus on clarity.";

setPopupPayload({

idea:{
title:startupName,
description:context
},

type:"feedback",

aiMessageOverride:tip

});

setShowPopup(true);

setTimeout(()=>{

setShowPopup(false);

setPopupPayload(null);

},3500);

}catch(err){

console.log("AI tip failed:",err);

}

};

/* GENERATE */

const generatePitchDeck=async()=>{

setLoading(true);

try{

const res=await axios.post("/api/pitchdeck",{

startupName,

startupData,

ideaId

});

if(!res.data?.pitchDeck?.slides){

alert("Pitch generation failed");

return;

}

setPitchDeck(res.data.pitchDeck.slides);

setAnalysis(res.data.pitchDeck.analysis||{});

setInvestorQuestions(res.data.pitchDeck.investorQuestions||[]);

setImprovements(res.data.pitchDeck.improvements||[]);

setSelectedDeckId(res.data.pitchDeck._id||null);

triggerMotivation("Investor narrative generated");

}catch{

alert("Generation failed");

}

finally{

setLoading(false);

}

};

/* AUTO SAVE */

const scheduleAutoSaveSlide=(index,slideData)=>{

if(!selectedDeckId)return;

if(autoSaveTimersRef.current[index]){

clearTimeout(autoSaveTimersRef.current[index]);

}

autoSaveTimersRef.current[index]=setTimeout(async()=>{

await axios.put(

`/api/pitchdeck/${selectedDeckId}/slide/${index}`,

slideData

);

},800);

};

/* SAVE */

const saveEditedSlide = async (index) => {
  try {
    await axios.put(
      `/api/pitchdeck/${selectedDeckId}/slide/${index}`,
      pitchDeck[index]
    );

    // ✅ show success
    setSaveStatus(prev => ({
      ...prev,
      [index]: "saved"
    }));

    // auto hide after 2 sec
    setTimeout(() => {
      setSaveStatus(prev => ({
        ...prev,
        [index]: null
      }));
    }, 2000);

  } catch (err) {
    setSaveStatus(prev => ({
      ...prev,
      [index]: "error"
    }));
  }
};

/* REGENERATE */

const regenerateSlide = async (index) => {
  const currentSlide = pitchDeck[index];

  const res = await axios.post(
    "/api/pitchdeck/regenerate-slide",
    {
      index,
      slideTitle: currentSlide.slide,   // ✅ send title
      previousContent: currentSlide.content, // optional
      startupData
    }
  );

  const updated = [...pitchDeck];

  updated[index] = {
    slide: currentSlide.slide, // ✅ LOCK TITLE
    content: res.data.slide.content // ✅ ONLY update content
  };

  setPitchDeck(updated);
};

/* UNIVERSAL PDF */

const generateInvestorReport = async () => {

try{

const response = await axios.post(

"/api/pdf/pitch-deck",

{
ideaId
},

{
responseType:"blob"
}

);

const file = new Blob(

[response.data],

{type:"application/pdf"}

);

const url =
window.URL.createObjectURL(file);

const link =
document.createElement("a");

link.href = url;

link.download =
buildMDIHPdfName(startupName,"Investor");

document.body.appendChild(link);

link.click();

link.remove();

}catch(err){

console.error("PDF generation failed",err);

alert("Failed to generate investor report");

}

};

/* PROFESSIONAL PPT */

const exportToPPT=()=>{

if(!pitchDeck.length)return;

const pptx=new pptxgen();

pitchDeck.forEach((slide,i)=>{

const s=pptx.addSlide();

s.background={color:"FFFFFF"};

s.addText(slide.slide,{

x:0.7,

y:0.5,

fontSize:28,

bold:true,

color:"1F3A8A"

});

const bullets=slide.content

.split("\n")

.filter(Boolean)

.map(l=>l.replace("-","").trim());

s.addText(bullets,{

x:0.8,

y:1.5,

w:8.5,

h:4.5,

fontSize:16,

bullet:true,

lineSpacing:28

});

});

pptx.writeFile(

`${startupName}_Investor_Pitch.pptx`

);

};

/* UI */

return(

<div className="bg-slate-50 min-h-screen">

<div className="max-w-5xl mx-auto px-6 py-12 space-y-10">

<ModuleHeader

title="Investor Pitch Builder"

subtitle="Prepare your startup for funding conversations"

badges={[

"Investor Ready",

"AI Generated",

"Editable",

"Funding Preparation"

]}

/>

{/* ACTIVE IDEA */}

        <div className="text-sm text-gray-500 border-b border-slate-200 pb-4 mb-6">

        <b>Startup:</b> {startupName}

        </div>

<div className="bg-white border rounded-xl p-6 flex justify-between">

<h3 className="font-semibold">

Generate investor pitch narrative

</h3>

<button

onClick={generatePitchDeck}

disabled={loading}

className="bg-blue-600 text-white px-6 py-3 rounded"

>

{loading?

"Generating":

"Generate Pitch"}

</button>

</div>

{pitchDeck.length>0 &&(

<>

<div className="flex gap-4">

<button

onClick={exportToPPT}

className="bg-indigo-700 text-white px-5 py-2 rounded"

>

Export Pitch PPT

</button>

<button

onClick={generateInvestorReport}

className="bg-slate-900 text-white px-5 py-2 rounded"

>

Generate Investor Report

</button>

</div>

{analysis?.overall &&(

<div className="bg-white border rounded-xl p-6">

<h3 className="font-semibold mb-3">

Investor Readiness

</h3>

<div className="grid grid-cols-2 gap-3 text-sm">

<div>Problem: {analysis.problemStrength}/10</div>

<div>Market: {analysis.marketStrength}/10</div>

<div>Execution: {analysis.executionCredibility}/10</div>

<div>Differentiation: {analysis.differentiationStrength}/10</div>

<div className="font-semibold">

Overall: {analysis.overall}/10

</div>

</div>

</div>

)}

<div className="space-y-6">

<h2 className="text-2xl font-semibold">

Pitch Narrative

</h2>

{pitchDeck.map((slide,index)=>(

<div

key={index}

className="bg-white border rounded-xl p-6"

>

<input

className="text-lg font-semibold w-full border-b"

value={slide.slide}

onChange={(e)=>{

const updated=[...pitchDeck];

updated[index].slide=e.target.value;

setPitchDeck(updated);

scheduleAutoSaveSlide(index,updated[index]);

}}

 />

<textarea

rows={4}

className="w-full border p-3 mt-3"

value={slide.content}

onChange={(e)=>{

const updated=[...pitchDeck];

updated[index].content=e.target.value;

setPitchDeck(updated);

scheduleAutoSaveSlide(index,updated[index]);

}}

 />
<div className="flex gap-4 mt-3 items-center">

<div className="flex items-center gap-2">
  <button
    onClick={() => saveEditedSlide(index)}
    className="text-green-600 font-medium"
  >
    Save
  </button>

  {saveStatus[index] === "saved" && (
    <span className="text-sm text-green-500">
      Saved ✓
    </span>
  )}

  {saveStatus[index] === "error" && (
    <span className="text-sm text-red-500">
      Failed ❌
    </span>
  )}
</div>

<button
  onClick={()=>regenerateSlide(index)}
  className="text-purple-600"
>
  Regenerate
</button>

</div>

</div>

))}

</div>

{improvements.length>0 &&(

<div className="bg-white border rounded-xl p-6">

<h3 className="font-semibold">

AI Improvement Suggestions

</h3>

<ul className="mt-3 text-sm space-y-1">

{improvements.map((i,idx)=>(

<li key={idx}>• {i}</li>

))}

</ul>

</div>

)}

{investorQuestions.length>0 &&(

<div className="bg-white border rounded-xl p-6">

<h3 className="font-semibold">

Investor Preparation Insights

</h3>

<ul className="mt-3 text-sm space-y-1">

{investorQuestions.map((q,idx)=>(

<li key={idx}>• {q}</li>

))}

</ul>

</div>

)}

<div className="bg-white border rounded-xl p-6 mt-10 flex justify-between items-center">

  <div>
    <h3 className="text-lg font-semibold text-gray-800">
      Ready to Match with Investors?
    </h3>

    <p className="text-sm text-gray-600 mt-1">
      Use your pitch insights to discover the most relevant investors,
      funding programs, and opportunities.
    </p>
  </div>

  <button
    onClick={() =>
      navigate("/funding-match", {
        state: { pitchDeck, startupData, ideaId }
      })
    }
    className="bg-pink-600 hover:bg-pink-700 text-white px-6 py-3 rounded-lg font-medium"
  >
    Go to Funding Match →
  </button>

</div>

</>

)}

</div>

{showPopup && popupPayload && (

<IdeaPopup

idea={popupPayload.idea}

type={popupPayload.type}

aiMessageOverride={popupPayload.aiMessageOverride}

/>

)}

</div>

);

};

export default PitchDeckGenerator;